import React, {Component, useEffect, useState} from "react";
import KeyValue from '../_core/KeyValue'
import {useNavigate, useParams} from "react-router";

export default function Item(props) {
    const [item, setItem] = useState('');

    const navigate = useNavigate()

    const {itemId} = useParams()

    useEffect(() => {
        document.title = 'Item'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    const fetchData = async () => {
        const url = API_URL + '/api/private/tanker/v1/items/' + itemId;

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                setItem(data);
            });
    }

    return (
        <div>
            <h2>Detail {itemId}</h2>
            <KeyValue pair={item}/>
        </div>
    )
}


